import { render } from "./TicketsTicketSummary.vue?vue&type=template&id=3f756b91"
import script from "./TicketsTicketSummary.vue?vue&type=script&lang=ts"
export * from "./TicketsTicketSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script